import { FC } from 'react';
import { GeneralIndicatorsProps } from './GeneralIndicators.types';
import { Container, IndicatorsGrid, IndicatorCard } from './GeneralIndicators.styles';
import { AllieCircularProgressBar, AllieText } from '../../../components';


export const GeneralIndicators: FC<GeneralIndicatorsProps> = ({
  oee,
  availability,
  performance,
  quality,
  labels,
  showBorderCard = true,
  gap,
  breakpoint,
  isEmpty,
}) => {
  return (
    <Container gap={gap} breakpoint={breakpoint}>
      {labels.title && (
        <AllieText type="body1" weight={500}>
          {labels.title}
        </AllieText>
      )}
      <IndicatorsGrid gap={gap}>
        <IndicatorCard showBorderCard={showBorderCard}>
          <AllieText type="body2" weight={400}>
            {labels.oee}
          </AllieText>
          <AllieCircularProgressBar
            value={oee}
            strokeWidth={10}
            textValue={isEmpty ? labels.withoutData : undefined}
            classes={{
              text: isEmpty ? 'text-empty' : '',
            }}
          />
        </IndicatorCard>

        <IndicatorCard showBorderCard={showBorderCard}>
          <AllieText type="body2" weight={400}>
            {labels.availability}
          </AllieText>
          <AllieCircularProgressBar
            value={availability}
            strokeWidth={10}
            textValue={isEmpty ? labels.withoutData : undefined}
            classes={{
              text: isEmpty ? 'text-empty' : '',
            }}
          />
        </IndicatorCard>

        <IndicatorCard showBorderCard={showBorderCard}>
          <AllieText type="body2" weight={400}>
            {labels.performance}
          </AllieText>
          <AllieCircularProgressBar
            value={performance}
            strokeWidth={10}
            textValue={isEmpty ? labels.withoutData : undefined}
            classes={{
              text: isEmpty ? 'text-empty' : '',
            }}
          />
        </IndicatorCard>

        <IndicatorCard showBorderCard={showBorderCard}>
          <AllieText type="body2" weight={400}>
            {labels.quality}
          </AllieText>
          <AllieCircularProgressBar
            value={quality}
            strokeWidth={10}
            textValue={isEmpty ? labels.withoutData : undefined}
            classes={{
              text: isEmpty ? 'text-empty' : '',
            }}
          />
        </IndicatorCard>
      </IndicatorsGrid>
    </Container>
  );
};
